import { Component, Prop, Mixins } from 'vue-property-decorator';

@Component
/**
 * Faq Props
 */
export default class Props extends Mixins() {
    /**
     * Classes
     */
    @Prop() classes!: string | Array<string>;

    /**
     * Testimonials Items
     */
    @Prop() items!: Array<{[k: string]: any}>;
}
